export let apiconfig = { 
  'base_url': 'https://grocer-claims-lco-backend.azurewebsites.net/api/v1/'
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/apiconfig.ts